import { FilteredMatchesWithEvents } from '../match-list/utils/match-list-models';
import { BemMethod, createBem } from '@om-fe/utils';

export type MatchListGroupData = FilteredMatchesWithEvents;

export const MATCHLIST_GROUP_BEM: BemMethod = createBem('MatchListGroup');
